import HiveCell from './HiveCell';

export default HiveCell;